module.exports = __webpack_public_path__ + "img/default2.41a232be.jpg";